import { track } from '@amplitude/analytics-browser'

import { trackingEvents } from 'modules/core/lib/Tracking/events'

import type { RecommendationAction } from 'modules/timeoff/components/LeaveApprovalRecommendation/RecommendationAction'

export const trackApprovalRecommendation = (
  action: 'approve' | 'reject',
  recommendedAction: RecommendationAction
) => {
  const eventName =
    action === 'approve'
      ? trackingEvents.timeoff.leaveApprovalRecommendation.approveLeave
      : trackingEvents.timeoff.leaveApprovalRecommendation.rejectLeave

  track(eventName, {
    action: action,
    recommended_action: recommendedAction,
    resource_type: 'timeoff',
  })
}
